import React, { useEffect } from "react";
import useGlobal from "store";
import PanelHeader from "components/PanelHeader/PanelHeader";
import { Row, Col, Card, CardHeader, CardTitle, CardBody, Table } from "reactstrap";
import {Elements } from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import CreditCardForm from "./CreditCardForm";
import InvoiceTableRow from "./InvoiceTableRow";

const Account = (props) => {

    const [user, actions] = useGlobal(
      state => state.user,
      actions => actions
    );

    const [invoices] = useGlobal(
        state => state.invoices
    );
    
    const STRIPE_PUB_KEY = (process.env.NODE_ENV === "development") 
                ? "pk_test_51HJKijFFO6RzyUk0QbqXdf30FPXM1vgXFNiN0qQVaV3qkwyOG3THAkOgo37FrB5bJ4kbo2wTHUPXXSqrEchdxQJb000gu1tU8p" 
                : "pk_live_51HJKijFFO6RzyUk0Lc3OF1DUc1JtPb5W2txfKFU81wofrCyeBmbL9ipkvkstP7PgSvm2SrAoupK3OBD8jZey9QNH00j4WJcCa7";

    const stripePromise = loadStripe(STRIPE_PUB_KEY);


    useEffect(() => {
        if(!user) {
            return;
        }
        actions.userActions.getUserInvoices();
    }, [user, actions]);

    const invoiceTable = invoices.reverse().map(inv => <InvoiceTableRow key={inv.id} {...inv}></InvoiceTableRow>)
    return (
        <>
        <PanelHeader size="sm" />
        <div className="content">
          
          {user ?
            <Row>
                <Col md="6">
                    <Card className="card-chart">
                        <CardHeader>
                            <h5 className="card-category">Billing History</h5>
                            <CardTitle tag="h2">Billing History</CardTitle>
                        
                        </CardHeader>
                        <CardBody>
                        <Table responsive>
                            <tbody>{invoiceTable}</tbody>
                        </Table>
                        </CardBody>
                    </Card>
                </Col>
                <Col md="6">
                    <Card>
                        <CardHeader>
                            <CardTitle tag="h4">Payment Settings</CardTitle>
                        </CardHeader>
                        <CardBody>
                            {user && user.payment_method && user.payment_method.payment_type && user.payment_method.last_four
                                ? <p className="text-success text-center"><i className={"now-ui-icons ui-1_check"}></i> Active Payment Method: <em>{user.payment_method.payment_type.toUpperCase()} ends in {user.payment_method.last_four}</em></p>
                                : user && user.payment_method ? <></> : <p className="text-danger text-center">Please add a payment method</p> }
                            <Elements stripe={stripePromise}>
                                <CreditCardForm></CreditCardForm>
                            </Elements>
                        </CardBody>
                    </Card>
                </Col>
            </Row> : <></> }
        </div>
        
        </>
    );
}

export default Account;